// extracted by mini-css-extract-plugin
export default {"removeButton":"AddressesEdit_removeButton__j4bZE"};